module.exports = __webpack_public_path__ + "public-roadmap-3-39a4268a645a1ec8b3ecd7dfac8cd5d5.webp";